export function envBUILD_TIME(): string | undefined {
    return process.env.REACT_APP_BUILD_TIME;
}
